import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { validateFunction } from "./validations.js";
import { parseJsValue } from "./parseJsValue.js";
import { parseResourceCall } from "./parseResourceCall.js";
export function parseUseResource(decl, args, state, app, options) {
  var declId = decl.get("id");
  if (!declId.isArrayPattern()) {
    return null;
  }
  var elements = declId.get("elements");
  if (elements.length !== 1 && elements.length !== 2) {
    return null;
  }
  var resourceVar = elements[0];
  if (!resourceVar.isIdentifier()) {
    return null;
  }
  if (args.length !== 1 && args.length !== 2) {
    return null;
  }
  var resourcePath = args[0];
  if (!resourcePath.isArrowFunctionExpression()) {
    return null;
  }
  if (!validateFunction(resourcePath.node, state)) {
    return null;
  }
  var call = resourcePath.get("body");
  if (call.isBlockStatement()) {
    return null;
  }
  if (!call.isCallExpression()) {
    return null;
  }
  var callee = call.get("callee");
  if (!(callee.isIdentifier() || callee.isMemberExpression())) {
    return null;
  }
  var resourceConfig = args[1];
  var config;
  if (resourceConfig) {
    if (!resourceConfig.isObjectExpression()) {
      state.errors.push({
        message: "\"useResource()\" second argument must be an object expression, but got ".concat(resourceConfig.type),
        node: resourceConfig.node,
        severity: "error"
      });
      return null;
    }
    var _iterator = _createForOfIteratorHelper(resourceConfig.get("properties")),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (!prop.isObjectProperty()) {
          state.errors.push({
            message: "Unsupported property type in \"useResource()\" second argument: ".concat(prop.type),
            node: prop.node,
            severity: "error"
          });
          return null;
        }
        var key = prop.get("key");
        if (!key.isIdentifier()) {
          state.errors.push({
            message: "\"useResource()\" second argument property key must be an identifier, but got ".concat(key.type),
            node: key.node,
            severity: "error"
          });
          return null;
        }
        if (prop.node.computed) {
          state.errors.push({
            message: "\"useResource()\" second argument property key cannot be computed",
            node: key.node,
            severity: "error"
          });
          return null;
        }
        if (key.node.name !== "enabled" && key.node.name !== "fallback") {
          state.errors.push({
            message: "\"useResource()\" second argument property key must be \"enabled\" or \"fallback\", but got \"".concat(key.node.name, "\""),
            node: key.node,
            severity: "error"
          });
          return null;
        }
        config !== null && config !== void 0 ? config : config = {};
        config[key.node.name] = parseJsValue(prop.get("value"), state, app, options);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var resource = null;
  if (callee.isMemberExpression()) {
    var property = callee.get("property");
    if (!property.isIdentifier() || callee.node.computed || property.node.name !== "then" && property.node.name !== "catch") {
      state.errors.push({
        message: "Invalid useResource call",
        node: property.node,
        severity: "error"
      });
      return null;
    }
    resource = parseResourceCall(callee.get("object"), state, app, options, resourceVar.node.name, config, call.get("arguments"), property.node.name);
  } else {
    resource = parseResourceCall(call, state, app, options, resourceVar.node.name, config);
  }
  if (resource) {
    var bindings = [{
      id: resourceVar.node,
      kind: "resource",
      resource: resource
    }];
    var refetchVar = elements[1];
    if (refetchVar) {
      if (!refetchVar.isIdentifier()) {
        state.errors.push({
          message: "Refetch variable in \"useResource()\" must be an identifier",
          node: refetchVar.node,
          severity: "error"
        });
        return null;
      }
      bindings.push({
        id: refetchVar.node,
        kind: "refetch",
        resourceId: resourceVar.node
      });
    }
    return bindings;
  }
  return null;
}
//# sourceMappingURL=parseUseResource.js.map